import Vue from 'vue'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import it from "vee-validate/dist/locale/it.json";
import * as rules from "vee-validate/dist/rules";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("it", it);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta';

import {BootstrapVue} from 'bootstrap-vue'

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../../assets/css/style.css'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(VueMeta);

import '@/mixins/helper';
import { loadRecaptcha } from '@/config/recaptcha';

// Carica reCAPTCHA v3 all'avvio: se lo script non e' raggiungibile
// il tool resta comunque utilizzabile, il token sara' semplicemente nullo.
loadRecaptcha().catch(error => console.log('recaptcha', error));

// Vue Lodash - Functions utilities
import VueLodash from 'vue-lodash'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'

Vue.use(VueLodash, {name: 'custom', lodash: {cloneDeep, isEmpty}})

import crypto from 'node-cryptojs-aes';

Object.defineProperty(Vue.prototype, '$crypto', {value: crypto});

Vue.config.productionTip = false

Number.prototype.pad = function (n) {
  return new Array(n).join('0').slice((n || 2) * -1) + this;
}
if (process.env.VUE_APP_WEB_PATH === 'https://www.asteaenergia.it/wp/') {
  Sentry.init({
    Vue,
    dsn: "https://05f57a4d22b044ffb3129dd78b2954fc@o1037232.ingest.sentry.io/6004973",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", process.env.VUE_APP_DOMAIN, /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}


Vue.mixin({
  methods: {
    showAlertModal(message, noRetry = false) {
      const h = this.$createElement
      // Using HTML string
      // More complex structure
      const messageVNode = h('div', {class: ['alert-box']}, [
        h('b-img', {
          props: {
            src: process.env.VUE_APP_WEB_CONF_PATH + 'img/alert.png',
            center: true,
            fluid: true,
          }
        }),
        h('p', {class: ['text-center','p-medium-gray-600']}, [message]),
      ])
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxOk([messageVNode], {
        title: ' ',
        centered: true,
        size: 'md',
        hideHeaderClose: ( noRetry ? true : false ),
        modalClass: ( noRetry ? "modal-alert modal-fail" : "modal-alert" ),
        headerClass: "container",
        bodyClass: "container",
        scrollable: true,
        hideFooter: true
      })
        .then(() => {
          if(noRetry == 1)  window.location.href = "https://www.asteaenergia.it";
          return true;
        })
        .catch(() => {
          return false;
        })
    },
    captureMessageSentry(message)
    {
      Sentry.captureMessage(message)
    },
    captureExceptionSentry(exception)
    {
      Sentry.captureException(exception)
    },
    isValidJSONString(str) {
      try {
        JSON.stringify(str)
      } catch (e) {
        return false;
      }
      return true;
    },
    numberFormat(number){
      if(!isNaN(number)) {
        return new Intl.NumberFormat('it-IT').format(number);
      }
      return number;
    },
    decryptAES(data){
      try {
        if(this.isValidJSONString(data))
        {
          var CryptoJS = this.$crypto.CryptoJS;
          var CryptoJSAesJson = {
            'parse': function (jsonStr) {
              var j = JSON.parse(jsonStr)
              var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
              if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
              if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
              return cipherParams
            }
          }
          let dataString = JSON.stringify(data)
          let decrypted = JSON.parse(CryptoJS.AES.decrypt(dataString, process.env.VUE_APP_CRYPTO_PASS, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8));
          return JSON.parse(decrypted);
        }
        this.captureMessageSentry('Error decryptAES() ' + data);
        return false;
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  }
})

const app = new Vue({
  data: {loading: false, footer: true},
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  app.loading = true
  if(to.params.steps) app.loading = false
  app.footer = true
  next()
})

router.afterEach(() => {
  setTimeout(() => app.loading = false, 300) // timeout for demo purposes
})
